import React from "react";

function Footer() {
  return (
    <footer className="footer p-1 gradientBackground" >
      <div className="content has-text-centered">
        <h5 className="has-text-light">Made with love & lots of ☕</h5>
      </div>
    </footer>
  );
}

export default Footer; 
